// ReportViewer.js
import React, { useState, useEffect } from 'react';
import { Box, Text, Textarea, Button, Flex } from '@chakra-ui/react';
import ReactMarkdown from 'react-markdown';

const ReportViewer = ({ reportContent, isEditing, onEditSave, onCancelEdit }) => {
  const [editContent, setEditContent] = useState(reportContent);

  useEffect(() => {
    // When the reportContent changes, update the editContent state
    setEditContent(reportContent);
  }, [reportContent]);

  const handleSave = () => {
    onEditSave(editContent);
  };
  const handleCancel = () => {
    // Call the onCancelEdit function passed from the parent to handle the cancellation
    onCancelEdit();
  };


  return (
    <Box bg="gray.100" p={4} borderRadius="md" overflow-y="auto" minHeight="400px" maxWidth="80%">
      <Text fontSize="md" mb={2} fontWeight="semibold">Research Report:</Text>
      {isEditing ? (
        <>
          <Textarea
            value={editContent}
            onChange={(e) => setEditContent(e.target.value)}
            size="md"
            maxWidth="80%"
            minHeight="350px" // Adjust this to match the non-editable state height
          />
          <Flex justifyContent="space-between" mt={2}>
            <Button colorScheme="blue" onClick={handleSave}>Save</Button>
            <Button colorScheme="red" onClick={handleCancel}>Cancel</Button>
          </Flex>
        </>
      ) : (
        <div className="markdown">
        <ReactMarkdown children={reportContent || 'No research report generated yet.'} />
      
        </div>
        )}

    </Box>
  );
};

export default ReportViewer;
